import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity ProviderUsers


export interface ProviderUser {
    id: ID;

    
    email: string;

    
    name: string;

    
    description?: string;

    
    userType: UserType;

    
    providerId: ID;

    
    userId: ID;

    
    scopeGroupId: ID;

    
    providerUserScopeGroupId: ID;

    }




export interface CreateProviderUser {
    
    email: string;

    
    name: string;

    
    description?: string;

    
    userType: UserType;

    
    providerId: ID;

    
    
    
    }


export interface UpdateProviderUser {
    
    
    name: string;

    
    description?: string;

    
    userType: UserType;

    
    
    
    
    }

export interface PresentationProviderUserRequest {
    list: ListRequest,
    filter: {
        email: string,
        emailOr: boolean,
        name: string,
        nameOr: boolean,
        providerIdRefs?: ID[],
        userIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryProviderUser {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: ProviderUser): PrimaryProviderUser | undefined {
        return entity ? new PrimaryProviderUser(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryProviderUser {
        return new PrimaryProviderUser(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryProviderUser {
        let vals = path?.split('/');
        return new PrimaryProviderUser(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryProviderUser[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: ProviderUser): string {
    let fields = entity ? [
    entity.email,
            entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityProviderUser {
    id: PrimaryProviderUser;
    data: UpdateProviderUser;


    constructor(id: PrimaryProviderUser, data: UpdateProviderUser) {
        this.id = id;
        this.data = data;
    }
}
